// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"c25e4fc060a5a858","352":"854b0a7d8882d66e","704":"ad4b3fbab81afe19"}[chunkId] + ".css";
};